var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoPrint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.54,
    y: 5.81,
    width: 19.02,
    height: 6.18,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.03,42.13h16.04v-13.94H16.03v13.94Zm3.73-11.59h8.67c1.11,0,2,.89,2,2s-.89,2-2,2h-8.67c-1.11,0-2-.89-2-2s.89-2,2-2Zm0,5.67h8.67c1.11,0,2,.89,2,2s-.89,2-2,2h-8.67c-1.11,0-2-.89-2-2s.89-2,2-2Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.67,12h-2.11V3.81c0-1.11-.89-2-2-2H12.54c-1.11,0-2,.89-2,2V12h-2.22c-2.21,0-4,1.79-4,4v12.8c0,2.21,1.79,4,4,4h.95v-4h-.95V16h31.35v12.8h-1.05v4h1.05c2.21,0,4-1.79,4-4V16c0-2.21-1.79-4-4-4ZM14.54,5.81h19.02v6.18H14.54V5.81Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.07,24.2H14.03c-1.11,0-2,.89-2,2v17.94c0,1.11,.89,2,2,2h20.04c1.11,0,2-.89,2-2V26.2c0-1.11-.89-2-2-2Zm-2,17.94H16.03v-13.94h16.04v13.94Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.33,17.9h-1.9c-1.11,0-2,.89-2,2s.89,2,2,2h1.9c1.11,0,2-.89,2-2s-.89-2-2-2Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.75,34.54h8.67c1.11,0,2-.89,2-2s-.89-2-2-2h-8.67c-1.11,0-2,.89-2,2s.89,2,2,2Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.75,40.21h8.67c1.11,0,2-.89,2-2s-.89-2-2-2h-8.67c-1.11,0-2,.89-2,2s.89,2,2,2Z",
    fill: outlineColor
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -0.03,
    width: 48,
    height: 48,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPrint);
export default __webpack_public_path__ + "static/media/ico-print.d103cbce83f0e80855f469a05cb48f18.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;